import React, { Component, lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';
import LoadingScreen from './components/Loading/Loading';

const Login = lazy(() => import('./pages/Login/Login'));
const Home = lazy(() => import('./pages/Home/Home'));
const Category = lazy(() => import('./pages/Category/Category'));
const Register = lazy(() => import('./pages/Register/Register'));
const PhoneVerify = lazy(() => import('./pages/PhoneVerify/PhoneVerify'));
const NoMatch = lazy(() => import('./pages/NoMatch/NoMatch'));
const Cart = lazy(() => import('./pages/Cart/Cart'));
const SingleProduct = lazy(() => import('./pages/SingleProduct/SingleProduct'));
const Profile = lazy(() => import('./pages/Profile/Profile'));
const Checkout = lazy(() => import('./pages/Checkout/Checkout'));
const OrderDone = lazy(() => import('./pages/OrderDone/OrderDone'));
const ForgetPassword = lazy(() => import('./pages/ForgetPassword/ForgetPassword'));
const ResetPassword = lazy(() => import('./pages/ResetPassword/ResetPassword'));
const PasswordThank = lazy(() => import('./pages/PasswordThank/PasswordThank'));
const Recipes = lazy(() => import('./pages/Recipes/Recipes'));
const SingleRecipes = lazy(() => import('./pages/SingleRecipes/SingleRecipes'));
const SingleOrder = lazy(() => import('./pages/SingleOrder/SingleOrder'));
const FAQS = lazy(() => import('./pages/FAQS/FAQS'));
const Terms = lazy(() => import('./pages/terms/Terms'));
const About = lazy(() => import('./pages/About/About'));
const Contact = lazy(() => import('./pages/Contact/Contact'));

const base = '/:locale(en|ar)?';

class Routes extends Component {
  render() {
    return (
      <Suspense fallback={<LoadingScreen />}>
        <Route exact path={base} render={() => <Home />} />

        <Route exact path={`${base}/login`} render={() => <Login />} />
        <Route exact path={`${base}/register`} render={() => <Register />} />
        <Route
          exact
          path={`${base}/forget-password`}
          render={() => <ForgetPassword />}
        />
        <Route exact path={`${base}/reset-password`} render={() => <ResetPassword />} />
        <Route
          exact
          path={`${base}/phone-verification`}
          render={() => <PhoneVerify />}
        />
        <Route
          exact
          path={`${base}/password-changed`}
          render={() => <PasswordThank />}
        />

        <Route exact path={`${base}/profile`} render={() => <Profile />} />
        <Route
          exact
          path={`${base}/profile/:id/:name`}
          render={() => <Profile />}
        />

        <Route exact path={`${base}/recipes`} render={() => <Recipes />} />
        <Route
          exact
          path={`${base}/recipes/:id`}
          render={() => <SingleRecipes />}
        />
        <Route
          exact
          path={`${base}/recipe/:id/:name`}
          render={() => <SingleRecipes />}
        />
        <Route
          exact
          path={`${base}/product/:id/:name`}
          render={() => <SingleProduct />}
        />
        <Route
          exact
          path={`${base}/category/:lvlId/:id/:name`}
          render={() => <Category />}
        />
        <Route exact path={`${base}/deals`} render={() => <Category />} />
        <Route exact path={`${base}/cart`} render={() => <Cart />} />
        <Route exact path={`${base}/checkout`} render={() => <Checkout />} />
        <Route exact path={`${base}/contact-us`} render={() => <Contact />} />
        <Route
          exact
          path={`${base}/order-placed`}
          render={() => <OrderDone />}
        />
        <Route
          exact
          path={`${base}/FAQs`}
          render={() => <FAQS />}
        />
        <Route
          exact
          path={`${base}/about`} 
          render={() => <About />}
        />
        <Route
          exact
          path={`${base}/terms-and-conditions`}
          render={() => <Terms />}
        />
        <Route
          exact
          path={`${base}/order-info/:id`}
          render={() => <SingleOrder />}
        />
        <Route
          exact
          path={`${base}/brand/:id/:name`}
          render={() => <Category />}
        />
        <Route
          exact
          path={`${base}/search/:name`}
          render={() => <Category />}
        />

        <Route exact path={`${base}/404`} component={NoMatch} />
      </Suspense>
    );
  }
}

export default Routes;
